"use-strict";

import '../assets/plugins/waypoint/noframework.waypoints.min';
export class Anchors {
    empresa = document.getElementById('empresa');
    missao = document.getElementById('missao');
    viabilidade = document.getElementById('viabilidade');
    bim = document.getElementById('plataforma-bim');
    projetos = document.getElementById('servicos');
    navLink = document.getElementsByClassName('nav-link');
    portfolio = document.getElementById('portfolio');
    constructor() {
        this.init();
    }

    init() {
        this.initAnchors();
        if (this.empresa !== null && this.empresa !== undefined) {
            const waypointEmpresa = this.getWithId('empresa');
        }
        if (this.missao !== null && this.missao !== undefined) {
            const waypointMissao = this.getWithId('missao');
        }
        if (this.viabilidade !== null && this.viabilidade !== undefined) {
            const waypointViabilidade = this.getWithId('viabilidade');
        }
        if (this.bim !== null && this.bim !== undefined) {
            const waypointBim = this.getWithId('plataforma-bim');
        }
        if (this.projetos !== null && this.projetos !== undefined) {
            const waypointProjetos = this.getWithId('servicos');
        }
        if (this.portfolio !== null && this.portfolio !== undefined) {
            const waypointPortfolio = this.getWithId('portfolio');
        }
    }

    scrollEvent(ev, element) {
        const menu = document.querySelector('#nav');
        const headerHeight = document.getElementById('section-header').offsetHeight;
        if (menu.className.search('nav--open') > 0) {
            menu.classList.remove('nav--open');
        }
        ev.preventDefault();
        const link = element.dataset.ref;
        const currEl = document.getElementById(link);
        currEl.removeAttribute('id');
        window.location.hash = link ;
        let topOfEl = window.pageYOffset + currEl.getBoundingClientRect().top -  100;
        topOfEl = topOfEl > 1 ?  topOfEl : 1;
        window.scroll({top: topOfEl, behavior: 'smooth', });
        currEl.setAttribute('id', link);
    }

    initAnchors() {
        if (this.navLink.length > 0) {
            Array.from(this.navLink).forEach(el => {
                el.addEventListener('click', ev => this.scrollEvent(ev, el));
            });
        }
    }

    getWithId(id) {
        const transitionedElements = document.getElementsByClassName( id + '-transitioned');
            if (transitionedElements.length > 0) {
                Array.from(transitionedElements).forEach(element => {
                    this.startWaypoint(null, element);
                });
            }
    }

    startWaypoint(id = null, element) {
        return new Waypoint({
            element,
            handler: (direction) => {
                this.handle(direction, element);
            },
            offset: '80%'
        });
    }

    handle(direction, element) {
        if (direction !== 'down') {
            return false;
        }
        if (element.classList.contains('from-right')) {
            element.classList.add('from-right-disabled');
        }
        if (element.classList.contains('from-left')) {
            element.classList.add('from-left-disabled');
        }
    }
}
